/**
 * @generated SignedSource<<25ba11dce916e4037e0058d55f0e2b12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AirportsRefetchQuery$variables = {
  search?: string | null;
};
export type AirportsRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AirportSelect_data">;
};
export type AirportsRefetchQuery = {
  response: AirportsRefetchQuery$data;
  variables: AirportsRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AirportsRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AirportSelect_data"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AirportsRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 10
          },
          (v1/*: any*/)
        ],
        "concreteType": "Airport",
        "kind": "LinkedField",
        "name": "airports",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "073f0a6d21b340bb88ec165beb07ae48",
    "id": null,
    "metadata": {},
    "name": "AirportsRefetchQuery",
    "operationKind": "query",
    "text": "query AirportsRefetchQuery(\n  $search: String\n) {\n  ...AirportSelect_data_40zwac\n}\n\nfragment AirportSelect_data_40zwac on Query {\n  airports(first: 10, search: $search) {\n    id\n    name\n    code\n  }\n}\n"
  }
};
})();

(node as any).hash = "d78d44d5a841215ffb074b8e074109fd";

export default node;
